import { Avatar } from "PFComponents/avatar";
import BadgesList from "PFComponents/badges_list/badges_list";
import Card from "PFComponents/card/card";
import InputFieldSet from "PFComponents/text/input_field_set";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import PropTypws from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ChangeRequestViewPage = ({ changeRequest }) => {
  const { t } = useTranslation("admin");
  const { first_name, last_name, summary, avatar, positions, custom_fields } = changeRequest?.data || {};
  const renderFirstBlock = first_name || last_name || summary || avatar;
  const cardStyle = { maxWidth: 900, marginBottom: 40, padding: "20px 0" };
  const { formatDate } = useDateFormatter();

  return (
    <div>
      <Link to={`/admin/change_requests/${changeRequest?.profile_id}`}>
        &laquo; {t("changeRequests.back")}
      </Link>
      <h1>{t("changeRequests.title")}</h1>
      <div style={{ marginBottom: 20 }}>{t("changeRequests.source", { source: changeRequest?.source })}</div>
      {renderFirstBlock && (
        <Card style={cardStyle}>
          {first_name && <InputFieldSet readOnly value={first_name} label={t("changeRequests.firstName")} />}
          {last_name && <InputFieldSet readOnly value={last_name} label={t("changeRequests.lastName")} />}
          {summary && (
            <InputFieldSet
              readOnly
              value={summary}
              label={t("changeRequests.summary")}
              inputType="textarea"
            />
          )}
          {avatar && (
            <div>
              {t("changeRequests.avatar")}
              <Avatar imagePath={avatar.url} />
            </div>
          )}
        </Card>
      )}
      {positions && (
        <>
          <h2>{t("changeRequests.positions")}</h2>
          <Card style={cardStyle}>
            {positions.map((position, index) => (
              <div key={index} style={{ marginBottom: 20 }}>
                <div>{formatDate(position.start_date)}</div>
                <h3>{position?.title}</h3>
                <div>{position?.subtitle}</div>
                <InputFieldSet
                  readOnly
                  inputType="textarea"
                  minHeight={"100%"}
                  maxHeight={"100%"}
                  value={position.summary}
                  label={
                    position.current
                      ? t("changeRequests.postionCurrent")
                      : position?.main
                      ? t("changeRequests.postionMain")
                      : ""
                  }
                />
              </div>
            ))}
          </Card>
        </>
      )}
      {custom_fields && (
        <>
          <h2>{t("changeRequests.customFields")}</h2>
          <Card style={cardStyle}>
            {custom_fields.map((cf, index) => (
              <div key={index}>
                <h3>{cf.type.name}</h3>
                <BadgesList values={cf.values.map(({ value }) => ({ text: value }))} />
              </div>
            ))}
          </Card>
        </>
      )}
      <>
        <h2>{t("changeRequests.rawData")}</h2>
        <Card style={cardStyle}>
          <pre>{JSON.stringify(changeRequest, null, 4)}</pre>
        </Card>
      </>
    </div>
  );
};

ChangeRequestViewPage.propTypes = {
  changeRequest: PropTypws.object
};

export default ChangeRequestViewPage;
